import Vue from "vue";
import Vuex from "vuex";
import authStore from "../modules/auth/store";
import adminStore from "../modules/Admin/store";
import essStore from "../modules/ess/store";

import actions from "./actions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    employees: [],
  },
  mutations: {
    employees(state, employees) {
      return (state.employees = employees);
    },
  },
  actions,
  modules: {
    auth: authStore,
    admin: adminStore,
    ess: essStore,
  },
});
